import React from 'react';
import { supabase } from '../../supabaseClient';
import { useToast } from '../../contexts/ToastContext';
import { Modal, ModalFooter } from '../ui/modal';

function DeleteProjectGroupModal({ show, handleClose, item, onItemUpdated, onItemDeleted }) {
  const addToast = useToast();

  const handleDelete = async () => {
    const { id } = item;
    const table = 'project_groups';
    const { error } = await supabase
      .from(table)
      .delete()
      .eq('id', id);

    if (error) {
      console.error('Error deleting item:', error);
      addToast('Error deleting item: ' + error.message, 'danger');
    } else {
      addToast('Item deleted successfully', 'success');
      console.log('Item deleted:', id);
      onItemDeleted(id);
      handleClose();
    }
  };

  return (
    <Modal isOpen={show} onClose={handleClose} title="Delete Project Group">
      <div className="space-y-3">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Are you sure you want to permanently delete this project group: "{item?.name}"?
        </p>
        <p className="text-sm text-red-600 dark:text-red-400">
          This action cannot be undone.
        </p>
      </div>
      
      <ModalFooter>
        <button
          type="button"
          onClick={handleClose}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleDelete}
          className="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        >
          Delete Project Group
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default DeleteProjectGroupModal;